(function () {
  function initWoodfurnistProductProof() {
    document.querySelectorAll('[data-wf-youtube]').forEach(function (button) {
      if (button.dataset.wfInitialized === 'true') return;

      button.dataset.wfInitialized = 'true';

      button.addEventListener('click', function () {
        var videoId = button.getAttribute('data-wf-youtube');

        if (!videoId) return;

        var iframe = document.createElement('iframe');

        iframe.src =
          'https://www.youtube-nocookie.com/embed/' +
          encodeURIComponent(videoId) +
          '?autoplay=1&rel=0';

        iframe.title = 'Woodfurnist workshop video';
        iframe.allow =
          'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        iframe.allowFullscreen = true;

        button.innerHTML = '';
        button.appendChild(iframe);
        button.classList.add('is-playing');
      });
    });

    document
      .querySelectorAll('[data-wf-open-custom-request]')
      .forEach(function (button) {
        if (button.dataset.wfInitialized === 'true') return;

        button.dataset.wfInitialized = 'true';

        button.addEventListener('click', function () {
          var customRequest = document.querySelector('.wf-custom-toggle');

          if (!customRequest) return;

          customRequest.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });

          setTimeout(function () {
            var box = customRequest.closest('.wf-custom-request-box');

            if (box && !box.classList.contains('is-open')) {
              customRequest.click();
            }
          }, 450);
        });
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initWoodfurnistProductProof
    );
  } else {
    initWoodfurnistProductProof();
  }

  document.addEventListener(
    'shopify:section:load',
    initWoodfurnistProductProof
  );
})();